interface DistrictDisplayData {
    slug: string;
    name: string;
}

export const getDistrictDisplayData = (district: {slug: string; short_name?: string}, citySlug: string): DistrictDisplayData => {
    const cityPrefix = `${citySlug}-`;

    return {
        slug: district.slug.startsWith(cityPrefix) ? district.slug.slice(cityPrefix.length) : district.slug,
        name: district.short_name?.split(",")[1]?.trim() ?? district.short_name ?? ""
    };
};
interface DistrictDisplayData {
    slug: string;
    name: string;
}

export const getDistrictDisplayData = (district: {slug: string; short_name?: string}, citySlug: string): DistrictDisplayData => {
    const cityPrefix = `${citySlug}-`;

    return {
        slug: district.slug.startsWith(cityPrefix) ? district.slug.slice(cityPrefix.length) : district.slug,
        name: district.short_name?.split(",")[1]?.trim() ?? district.short_name ?? ""
    };
};
